<template>
<div>
  <div v-show="!updating">
    <div class="mdl-grid">
      <div class="mdl-card mdl-cell mdl-cell--12-col mdl-shadow--2dp">
        <div class="mdl-card fill">
          <!-- subscription exists -->
          <div v-if="subscription.isActive">
            <div class="ga-form-title">
              <h2 class="ga-title-text">{{'subscription.label.title' | label}}</h2>
            </div>
            <div class="mdl-card__supporting-text fill">
              <div class="card-grid mdl-grid">
                <div class="mdl-cell mdl-cell--6-col">
                  <div class="profile-label">
                    {{ 'subscription.label.status' | label }}
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--6-col">
                  <div class="profile-text">
                    {{ subscription.status }}
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--12-col" v-if="subscription.status !== 'Pending'">
                  <div class="mdl-grid inner-grid">
                    <div class="mdl-cell mdl-cell--6-col">
                      <div class="profile-label">
                        {{ 'subscription.label.payment.method' | label }}
                      </div>
                    </div>
                    <div class="mdl-cell mdl-cell--6-col">
                      <div v-show="subscription.isActive" class="profile-text">
                        {{ (getLookup('PAYMENT_METHOD', subscription.paymentMethod).label || 'lookup.paymentMethod.undefined.'+subscription.paymentMethod) | label }}
                      </div>
                    </div>
                    <div class="mdl-cell mdl-cell--6-col">
                      <div class="profile-label">
                        {{ 'subscription.label.last.billing.date' | label }}
                      </div>
                    </div>
                    <div class="mdl-cell mdl-cell--6-col">
                      <div class="profile-text">
                        {{ subscription.billingPeriodStartDate | makeDate user.timeZone 'LL'}}
                      </div>
                    </div>
                    <div class="mdl-cell mdl-cell--6-col">
                      <div class="profile-label">
                        {{ 'subscription.label.last.billing.amount' | label }}
                      </div>
                    </div>
                    <div class="mdl-cell mdl-cell--6-col">
                      <div class="profile-text">
                        {{ transaction.amount | currency }}
                      </div>
                    </div>
                    <div class="mdl-cell mdl-cell--12-col">
                      <div class="mdl-grid inner-grid">
                        <div class="mdl-cell mdl-cell--6-col">
                          <div class="profile-label">
                            {{ 'subscription.label.next.billing.date' | label }}
                          </div>
                        </div>
                        <div class="mdl-cell mdl-cell--6-col">
                          <div class="profile-text">
                            {{ subscription.billingPeriodEndDate | makeDate user.timeZone 'LL'}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--6-col">
                </div>
                <div class="mdl-cell mdl-cell--6-col">
                  <div class="submit-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                    v-on:click="update()">
                    {{'subscription.button.update' | label}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-show="updating">
    <div class="mdl-grid">
      <div class="mdl-card mdl-cell mdl-cell--6-col mdl-shadow--2dp">
        <div class="mdl-card fill">
          <div class="ga-form-title">
            <h2 class="ga-title-text">{{'subscription.label.update' | label}}</h2>
          </div>
          <div class="mdl-grid">
            <div class="mdl-cell mdl-cell--12-col">
              {{ 'subscription.label.services.selection' | label}}
            </div>
            <!-- <div class="mdl-cell mdl-cell--6-col">
              <ul class="mdl-list">
                <li v-for="service in services" class="mdl-list__item">
                  <label class="mdl-checkbox mdl-js-checkbox" for="{{service.code}}">
                    <input type="checkbox" id="{{service.code}}" class="mdl-checkbox__input" name="services" value="{{service.code}}" v-model="selectedServices">
                    <span class="mdl-checkbox__label">{{ service.label | label }}</span>
                  </label>
                </li>
              </ul>
            </div> -->
            <div class="mdl-cell mdl-cell--12-col">
              <ul class="mdl-list">
                <template v-for="bp in billingPeriods">
                  <li v-if="!subscription.trialBurnt || !checkTrial(bp.code)" class="mdl-list__item" :key="bp.code">        <label class="mdl-radio mdl-js-radio">
                      <input type="radio" class="mdl-radio__button" name="billingPeriods" value="{{bp.code}}" v-model="billingPeriod" >
                      <span class="mdl-radio__label">{{ bp.label | label }}</span>
                    </label>
                  </li>
                </template>
              </ul>
            </div>
          </div>
        </div>
        <div class="mdl-card__actions pricing">
          <div class="mdl-grid">
            <div class="mdl-cell mdl-cell--10-col">
              <h5>{{ 'payment.label.pricing' | label }}</h5>
            </div>
            <div class="mdl-cell mdl-cell--2-col">
              <h5>{{ pricing | currency }}</h5>
              <!-- {{trial}} -->
            </div>
            <!-- <div class="mdl-cell mdl-cell--12-col">
              <div class="submit-button mdl-button mdl-js-button mdl-button--colored fill"
                v-on:click="updating = false">
                {{ 'subscription.button.back' | label}}
              </div>
            </div> -->
          </div>
        </div>
        <div class="mdl-card__menu">
          <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
              v-on:click="updating = false">
            <i class="material-icons">keyboard_arrow_left</i>
          </button>
        </div>
      </div>
      <div class="mdl-cell mdl-cell--6-col mdl-shadow--2dp">
      <!--  <div class="mdl-card fill"> -->
        <div class="mdl-card fill" v-bind:class="[{ trial: trial }]">
          <div class="ga-form-title">
            <h2 v-if="trial" class="ga-title-text">{{'subscription.label.trial.title' | label}}</h2>
            <h2 v-if="!trial" class="ga-title-text">{{'subscription.label.payment.title' | label}}</h2>
          </div>
          <subscribe-form :payload="paypalPayload"></subscribe-form>
        </div>
      </div>
    </div>
  </div>

  <div v-show="success" class="modal" transition="fade">
    <div class="mdl-dialog">
      <h3 class="mdl-dialog__title"></h3>
      <div class="mdl-dialog__content">
        <p>
          {{ 'subscription.message.success.title'  | label }}
          <!-- {{ 'subscription.message.success.keep' | label }}} -->
        </p>
      </div>
      <div class="mdl-dialog__actions">
        <div class="mdl-button mdl-js-button mdl-button--colored"><a v-link="{path: '/app/managed'}">{{ 'subscription.button.dialog.keep' | label}}</a></div>
        <div class="mdl-button mdl-js-button mdl-button--colored"
             v-on:click="deleteOldMessages()">{{ 'subscription.button.dialog.delete' | label}}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
var payment = require('api/Payment')
var actions = require('common/store/actions')
var getters = require('common/store/getters')
var lookupValue = require('vue').filter('lookupValue')
var lookup = require('vue').filter('lookup')
var api = require('api')
module.exports = {
  ready: function () {
    // user not active yet
    if (this.user.status === 'PENDING') {
      this.$router.replace('/app/userpending')
      return
    }
    if (this.user.subscription && this.user.subscription.status === 'Pending') {
      api.User.createPaymentUrl({id: this.user.id}).then((response) => {
        this.$router.replace('/app/payment/' + response.data.token)
      }).catch((err) => {
        this.$dispatch('show-error', err.data)
      })
      return
    }
    if (!this.user.hasMessageModel) {
      this.$dispatch('show-alert-message', 'profile.message.noMessageModel')
    } else if (!this.user.hasMessages) {
      this.$dispatch('show-alert-message', 'profile.message.noMessages')
    }
    this.$dispatch('loading', true)
    payment.getSubscription(this.load, this.onError)
  },
  beforeDestroy: function () {
    this.$dispatch('dismiss-alert-message')
  },
  vuex: {
    getters: getters,
    actions: actions
  },
  components: {
    subscribeForm: require('c/forms/SubscribeForm')
  },
  methods: {
    load: function (resp) {
      this.$dispatch('loading', false)
      this.success = resp.success || this.success
      this.subscription = resp.data.subscription
      this.transaction = resp.data.transaction
      this.selectedServices = ['DELAYED']
      this.updating = false
      this.billingPeriod = this.subscription.billingPeriodCode || 'BP1'
      let test = this.getLookup('PAYMENT_METHOD', this.subscription.paymentMethod)
      console.log('lookup key: ', lookup('PAYMENT_METHOD'))
      console.log(test)
    },
    update: function () {
      var self = this
      this.updating = true
      if (!this.paymentLoaded) {
        payment.getPricing('DELAYED', function (pricing) { /* TODO change!!!!!!*/
          payment.isTrial('DELAYED', function (trial) {
            self.service = {
              code: 'DELAYED',
              pricing: pricing,
              trial: trial
            }
            payment.getBillingPeriods('DELAYED', function (billingPeriods) {
              self.billingPeriods = billingPeriods.filter(function (bp) {
                return (bp.isActive && !self.subscription.trialBurnt) || (bp.isActive && self.subscription.trialBurnt && !self.checkTrial(bp.code)) // && bp.userReady
              })
              self.billingPeriod = self.billingPeriodCode || self.billingPeriods[0].code
  //            self.billingPeriod = self.billingPeriods[0].code
              payment.token(function (token) {
                self.$broadcast('payment-token', token)
                self.paymentLoaded = true
              }, self.onError)
            }, self.onError)
          }, self.onError)
          // self.billingPeriod = Object.keys(pricing)[0]
        }, self.onError)
        // payment.token(function (token) {
        //   self.$broadcast('payment-token', token)
        // }, self.onError)
      }
    },
    cancel: function () {
      var self = this
      self.$dispatch('loading', true)
      payment.cancelSubscription(function (resp) {
        self.$dispatch('show-success', 'subscription.message.cancel.successful')
        self.load(resp)
      }, this.onError)
    },
    onSuccess: function (resp) {
      var self = this
      self.$dispatch('loading', false)
      resp.success = true
      self.load(resp)
    },
    onError: function (err) {
      this.$dispatch('loading', false)
      this.$dispatch('show-error', err.data)
    },
    getLookup: function (key, value) {
      return lookupValue(lookup(key), value)
    },
    closeSuccessDialog: function () {
      this.success = false
    },
    deleteOldMessages: function () {
      var self = this
      this.success = false
      this.$dispatch('loading', true)
      api.Message.deleteAll({userId: this.user.id}).then(function () {
        self.$dispatch('loading', false)
        self.$route.router.go('/app/managed')
      }, self.onError)
    },
    checkTrial: function (billingPeriodCode) {
      return (this.service.trial ? this.service.trial[billingPeriodCode] : false)
    }
  },
  events: {
    'payload': function (payload) {
      var self = this
      self.$dispatch('loading', true)
      payload.userId = this.user.id
      payload.services = this.selectedServices
      payload.billingPeriod = this.billingPeriod
      if (payload.trial) {
        payment.activateTrial(payload, this.onSuccess, this.onError)
      } else {
        payment.confirmPayment(payload, this.onSuccess, this.onError)
      }
    },
    'paypal-success': function (resp) {
      resp.success = true
      this.$dispatch('show-success', 'subscription.message.update.success')
      this.load({data: resp, success: true})
    }
  },
  data: function () {
    return {
      subscription: {},
      transaction: {},
      selectedServices: ['DELAYED'],
      billingPeriod: '',
      pricing: 0,
      service: {},
      services: [{
        code: 'DELAYED',
        label: 'service.label.delayed'
      }],
      billingPeriods: [],
      updating: false,
      paymentLoaded: false,
      success: false
    }
  },
  watch: {
    service: function () {
      if (this.service.pricing && this.billingPeriod) {
        this.pricing = this.service.pricing[this.billingPeriod]
      }
    },
    billingPeriod: function () {
      if (this.service.pricing && this.billingPeriod) {
        this.pricing = this.service.pricing[this.billingPeriod]
      }
    }
  },
  computed: {
    isDonation: function () {
      return ['SCHEDULED'].indexOf(this.service.code) > -1
    },
    filterBillingPeriod: function () {
      return this.billingPeriodList.filter(function (bp) {
        return bp.userReady && bp.isActive
      })
    },
    paypalPayload: function () {
      const bp = this.billingPeriods.filter(item => item.code === this.billingPeriod)[0]
      const label = bp ? bp.label : undefined
      return {
        billingPeriod: this.billingPeriod,
        service: this.service.code,
        user: this.user,
        trial: (this.service.trial ? this.service.trial[this.billingPeriod] : false),
        pricing: this.pricing,
        itemLabel: label
      }
    },
    trial: function () {
      return (this.service.trial ? this.service.trial[this.billingPeriod] : false)
    }
  }
}
</script>

<style scoped>
  .inner-grid {
    margin: -8px;
    padding: 0;
  }
  .pricing {
    border-top: 1px solid silver;
    color: gray;
    /*font-weight: bold;*/
  }
  .cancel-link {
    color: red !important;
    text-transform: uppercase;
    cursor: pointer;
  }
  .mdl-dialog {
    width: auto;
    height: 100%;
  }
  .trial {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// Subscription.vue?8a74c022